import { Component, Mixins, Prop } from 'vue-property-decorator'
import { mapGetters } from 'vuex'
import { NumberMixin } from '@kwixeo/interface-vue'
import { BTabs, BTab, BBadge, BFormGroup } from 'bootstrap-vue'
import { TranslateResult } from 'vue-i18n'

@Component({
  computed: {
    ...mapGetters('user', ['currency'])
  },
  components: {
    BTabs, BTab, BBadge, BFormGroup
  }
})
export default class CustomPricesView extends Mixins(NumberMixin) {
  @Prop({ default: () => ({}) }) value!: KwixeoCatalog.Product

  get customPriceQuantityLabel (): TranslateResult|null {
    switch (this.value.custom_price_quantity_mode) {
      case 1:
        return this.$t('catalog.customPrices.qtyOnDocument')
      case 2:
        return this.$t('catalog.customPrices.qtyCurrentYear')
      case 3:
        return this.$t('catalog.customPrices.qtyPreviousYear')
      case 4:
        return this.$tc('catalog.customPrices.qtyLastNbMonths', this.value.custom_price_quantity_month_length)
      case 5:
        return this.$t('catalog.customPrices.qtyTotal')
      default:
        return null
    }
  }

  get customPriceCustomerTypes (): KwixeoCatalog.CustomPriceTypes {
    return this.value.custom_type_prices.filter((price: KwixeoCatalog.CustomPriceType) => price.type === 'customerType')
  }

  get customPriceCustomers (): KwixeoCatalog.CustomerPrices {
    return this.value.custom_type_prices.filter((price: KwixeoCatalog.CustomPriceType) => price.type === 'customer')
  }

  get customPriceCountries (): KwixeoCatalog.CustomerPrices {
    return this.value.custom_type_prices.filter((price: KwixeoCatalog.CustomPriceType) => price.type === 'country')
  }
}
